// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"107":"525b5c01","222":"ad089b34","570":"133c7475","698":"53d84287","922":"84cfe00e"}[chunkId] + ".chunk.js";
};